import React from "react";

export const Friends = (props) => {
  return (
    <div id="friends">
      <div className="container">
        <div className="col-md-12 text-center">
          <img src="img/title-friends.png" className="img-title" alt="" />
          <h3>邀請好友加入遊玩，不只讓遊戲更有趣，更能讓你與好友同時享有專屬回饋！<br></br><br></br>
            只要透過你的推薦連結成功加入，當好友開始遊玩，你即可同步獲得對應回饋，<br></br><br></br>
            雙方一起玩、一起累積紅利，輕鬆又划算。</h3>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="friends">
              <div className="friends-content img1 col-md-4 col-sm-12">
                <div className="friends-meta">分享推薦連結</div>
                <div className="friends-text"><p>將你的專屬連結傳給好友。</p></div>
              </div>
              <div className="friends-content img2 col-md-4 col-sm-12">
                <div className="friends-meta">好友成功加入</div>
                <div className="friends-text"><p>完成註冊和首儲並開始遊玩。</p></div>
              </div>
              <div className="friends-content img3 col-md-4 col-sm-12">
                <div className="friends-meta">雙方共同領取回饋</div>
                <div className="friends-text"><p>好友遊玩，你即可獲得回饋，好友也享有福利。</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
